import { render } from "./App.vue?vue&type=template&id=f2c04a30"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f2c04a30&lang=css"

import exportComponent from "/home/grimos10/gits/grimos10.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__